export default "__VITE_ASSET__C6UrjWp1__"